

import LayerRevwDtl from '@/components/pd/layer/LayerRevwDtl.vue' // 리뷰 상세 보기 레이어 팝업
import spbkMixin from '@/mixin/or/spbkMixin'
import { commonfunc } from '~/mixin/common'
import { isShowTotalSelling } from '~/config/options'
import { ONLINE_ONLY, QUICK_DELIVERY_ONLY } from '~/constants'
import { rules } from '~/mixin/common/product/productRules'
import ThumbOverlay from '@/components/common/product/ThumbOverlay.vue'
import HolidayDeliveryFlag from '~/components/common/product/HolidayDeliveryFlag.vue'
import BoxPdEmblem from '~/components/common/product/BoxPdEmblem.vue'
import BoxPdFlag from '~/components/common/product/BoxPdFlag.vue'
import RankingArea from '~/components/common/product/RankingArea.vue'
import BannerUnit from '~/components/common/product/BannerUnit.vue'
import ProdEmblem from '~/components/common/product/ProdEmblem.vue'
import ShoppingbagButton from '~/components/common/product/ShoppingbagButton.vue'
import ProdRelease from '~/components/common/product/ProdRelease.vue'
import ProdPrice from '~/components/common/product/ProdPrice.vue'
import ProdName from '~/components/common/product/ProdName.vue'
import ProdRating from '~/components/common/product/ProdRating.vue'
import ProdFlag from '~/components/common/product/ProdFlag.vue'
import * as ds from '~/scriptData/ds/dsCommon'

export default {
  name: 'ProdUnit',
  components: { HolidayDeliveryFlag, LayerRevwDtl, ThumbOverlay, BoxPdEmblem, BoxPdFlag, RankingArea, BannerUnit, ProdEmblem, ShoppingbagButton, ProdRelease, ProdPrice, ProdName, ProdRating, ProdFlag },
  mixins: [spbkMixin, commonfunc, rules],
  props: {
    item: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    unitType: { // 상품 type : Product - 상품 기본, Release - 판매 알림, Banner - 배너
      type: String,
      default: 'Product'
    },
    idx: { // 상품 index
      type: Number,
      default: 0
    },
    long: { // long type veideo
      type: Boolean,
      default: false
    },
    contwriter: { // 사용자 등록 상품 type
      type: Boolean,
      default: false
    },
    review: { // 리뷰 유닛
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    fbYn: { // 정기배송여부
      type: Boolean,
      default: false
    },
    bulkYn: { // 대량배송여부
      type: Boolean,
      default: false
    },
    recmYn: { // 추천 솔루션 조회 여부
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: null
    },
    resdataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    revwTotalCnt: {
      type: Number,
      default: 0
    },
    exhType: {
      type: String,
      default: ''
    },
    groobeeRecmData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      ONLINE_ONLY,
      QUICK_DELIVERY_ONLY,
      isShowTotalSelling,
      num: 0, // 수량
      getNotified: this.item.ancTrmsYn === 'Y', // 판매알림 신청여부
      //  / alert: {},
      msg: '',
      mb: this.$store.getters['session/getMb'],
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'],
      adltCtfcCd: this.$store.getters['session/getAdltCtfcCd'],
      imgUrl: this.item.pdImgUrl,
      testYn: this.isNotEmpty(this.item.pdImgUrl),
      planBoxSwiperOpt: { // 기획전 (신상품) 박스형 swiper options
        slidesPerView: 1,
        loop: false,
        lazy: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      inctStr: '', // 조회인원수
      showlayerRevwDtl: false,
      prodExhType: ds.getProdExhType(this.exhType)
    }
  },
  computed: {
    average () {
      return Number(this.item.avgStscVal).toFixed(1)
    },
    bestYn () {
      if (this.item.HOME_MAIN_SALE_RANK_RANKING !== '' && this.item.HOME_MAIN_SALE_RANK_RANKING !== undefined) {
        const arr = this.item.HOME_MAIN_SALE_RANK_RANKING.split('>')
        return arr[0]
      } else {
        return ''
      }
    },
    reviewNum () { // 23.08.25 수정
      if (this.item.revwCnt) {
        const revwNum = Number(this.item.revwCnt.replace(/[^0-9]/g, ''))
        // if (revwNum > 9999 && revwNum <= 99999) {
        //   return '9,9+ 천'
        // } else
        if (revwNum > 99999) {
          return '99,9+만'
        } else {
          return (revwNum >= 10000 ? Number.parseFloat(Math.floor(revwNum / 1000) / 10) + '만' : this.numberComma(Number.parseFloat(revwNum)))
        }
      } else {
        return '0'
      }
    },
    total () { // 23.08.25 수정
      if (this.item.totOrQy) {
        const totalNum = Number(this.item.totOrQy.replace(/[^0-9]/g, ''))
        // if (totalNum > 9999 && totalNum <= 99999) {
        // //  return '9.9+ 천'
        //   return '9,999+'
        // } else
        if (totalNum > 99999) {
          return '99.9+만'
        } else {
          return totalNum >= 10000 ? Number.parseFloat(Math.floor(totalNum / 1000) / 10) + '만' : this.numberComma(Number.parseFloat(totalNum))
        }
      } else {
        return '0'
      }
    },
    prodPrice () {
      if (typeof this.item.price === 'number') {
        return Number(this.item.price).toLocaleString('ko-KR')
      } else {
        return Number(this.item.price.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    rankFlag () {
      if (typeof this.item.ranking.variance === 'number') {
        if (this.item.ranking.variance === 0) { // 변동없음
          return ''
        } else { // up & down
          return Math.abs(this.item.ranking.variance)
        }
      } else {
        return 'new'
      }
    },
    // 판매 예정일 도래여부
    releasDt () {
      if (this.item.wrhParmDt) {
        return this.item.wrhParmDt.substr(0, 4) + '년 ' + this.item.wrhParmDt.substr(4, 2) + '월 ' + this.item.wrhParmDt.substr(6, 2) + '일'
      }
      return null
    },
    revwRank () {
      if (this.item.REVW_RANK !== undefined && this.item.REVW_RANK !== '' && this.item.REVW_RANK !== '0') {
        const arr = this.item.REVW_RANK.split('>')
        return arr[0]
      }
      return '0'
    },
    setVideo () {
      if ((this.item.pdCttsTy === '02') && this.item.pdImgUrl !== '') {
        const video = { // video 기본 옵션 설정
          controls: false, // 컨트롤 바 노출 여부
          autoplay: false, // 자동재생
          muted: true, // 음소거
          loop: true,
          preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
          poster: '', // 썸네일 이미지
          sources: [
            {
              src: '/images/tempLy/sample_detail.mp4',
              type: 'video/mp4'
            }
          ],
          playbackRates: [1] // 배속
        }
        video.sources[0].src = !this.review ? this.imgUrlMaker(this.item.pdImgUrl) : this.imgUrlMaker(this.item.revwImgUrl)

        //     console.table('video :::: ', video)
        return video
      } else {
        return {}
      }
    },
    setNoimage () {
      //  console.log(this.item.exhPdNm, 'image:::', this.item.pdImgUrl, ':: ', this.isNotEmpty(this.item.pdImgUrl))
      /// xcdr/capture/format=jpg  REVWCTTSTY
      if (!this.isNotEmpty(this.item.pdImgUrl)) {
        return '/images/tempLy/noimage.png'
      } else {
        return this.imgUrlMaker(this.item.pdImgUrl, '/dims/resize/320/quality/90')
      }
    },
    setNoReviewImage () {
      if (!this.isNotEmpty(this.item.revwImgUrl)) {
        return '/images/tempLy/noimage.png'
      } else {
        return this.item.REVWCTTSTY === '02' ? this.imgUrlMaker(this.item.revwImgUrl, '/xcdr/capture/format=jpg' + '/dims/resize/320/quality/90') : this.imgUrlMaker(this.item.revwImgUrl, '/dims/resize/320/quality/90')
      }
    },
    setBannerImg () {
      return this.imgUrlMaker(this.item.pcomIconAtchFileUrl, '/dims/resize/290/quality/90')
    },
    setEmblemImg () {
      if (this.item.emblem?.pcImgAtchFileUrl) {
        return this.imgUrlMaker(this.item.emblem?.pcImgAtchFileUrl)
      } else if (this.item.emblm?.emblmPcImgAtchFileUrl) {
        return this.imgUrlMaker(this.item.emblm?.emblmPcImgAtchFileUrl?.replace('\n', ''))
      } else {
        return null
      }
    },
    setSleStDtm () {
      let sleStDtm = ''

      if (this.isNotEmpty(this.item.sleStDt)) {
        sleStDtm = this.item.sleStDt
      } else if (this.isNotEmpty(this.item.SLE_ST_DTM)) {
        sleStDtm = this.item.SLE_ST_DTM
      }

      return sleStDtm
    },
    isBulkOrderUnit () {
      return this.$route.path.includes('bulkOrder') || this.$route.params.cartType === 'bulkOrder'
    },
    holidayDeliveryInfo () {
      return this.$store.getters['ds/getHolidayDeliveryInfo']
    }
  },
  watch: {
    // alert: {
    //   handler (obj) {
    //     this.$nuxt.$emit('onCommonAlertChange', obj)
    //   }
    // }
  },
  created () {
    // this.setNoimage()
  },
  mounted () {
    if (document.querySelectorAll('.goods-list.ugc.masonry').length > 0) {
      this.unitHeight()
    }
    this.inctStr = this.inctCnt(this.item.inct)

    if (this.isNotEmpty(this.$route.params.spbkSeCd)) {
      // eslint-disable-next-line vue/no-mutating-props
      this.item.spbkSeCd = this.$route.params.spbkSeCd
    }
  },
  unmounted () {
  },
  methods: {
    errorImage (e) {
      e.target.src = '/images/tempLy/noimage.png'
    },
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    isEmblemExisted () {
      return ((!!this.item.emblem && this.item.emblem?.aplMdiaPcomYn === 'Y') || (!!this.item.emblm && this.item.emblm?.emblmAplMdiaPcomYn === 'Y'))
    },
    alarmChk (event) {
      this.$emit('alarm-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    unitHeight () {
      document.querySelectorAll('.goods-list.ugc.masonry > .goods-unit').forEach((el) => {
        el.style.cssText = 'grid-row-end: span ' + (el.clientHeight + 0)
      })
    },
    setNotification (checked) {
      // 1. 로그인 여부 체크
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        // 로그인 이동 팝업
        this.getNotified = !this.getNotified
        this.$router.push('/mb/mbb/SCR_MBB_0097A')
        // this.$confirm(this.$t('SM.LOGIN'), '', {
        //   confirmButtonText: '확인',
        //   cancelButtonText: '취소'
        // }).then(() => { // 확인 버튼 클릭시
        // }).catch(() => { // 취소 버튼 또는 알림창 밖 클릭시
        // })
      } else {
        // 2. 판매 알림 신청
        this.notifyNewProduct(mbMngNo, checked)
      }
    },
    // 판매알림 신청하기
    async notifyNewProduct (userNo, checked) {
      const params = [{
        ancTy: '01', // 판매예정
        pdNo: this.item?.pdNo, // 상품번호
        mbMngNo: userNo // 회원번호
      }]
      await this.$AxiosBuilder
        .data(params)
        .build()
        .post('/pdo/ancRqRls')
        .then((res) => {
          if (res.data.success) {
            if (checked) {
              this.$notify({
                message: this.$t('PD.NOTIFY_NEWPD_SUCCESS'),
                position: 'center',
                showClose: false,
                duration: 3000
              })
            } else {
              this.$notify({
                message: this.$t('PD.NOTIFY_NEWPD_CANCEL'),
                position: 'center',
                showClose: false,
                duration: 3000
              })
            }
          }
        })
        .catch((e) => {
          throw new Error(e)
        })
    },
    openLayer (str) {
      this.showlayerRevwDtl = true
      this.$nextTick(() => {
        this.$refs.layerRevwDtl.data = { revwMngNo: Number(str) }
        this.$refs.layerRevwDtl.visible = true
      })
    },
    closeLayer () {
      this.showlayerRevwDtl = false
    },
    async adultCert (obj) {
      const returnUrlPath = `/pd/pdr/SCR_PDR_0001?pdNo=${obj.pdNo}&recmYn=${this.recmYn ? 'Y' : 'N'}`
      if (this.mb.mbMngNo === undefined) { // 로그인 정보가 없으면 로그인페이지로 이동
      //  if (await this.confirm(this.$t('PD.LOGIN_ADULT'))) {

        const nowPath = this.$route.fullPath
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: returnUrlPath, adltAuth: 'Y', adltReturnUrl: nowPath } })
        //  }
        return
      }
      if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '02') { // 로그인되어 있고 성인인증 미인증
      //  const url = this.$route.path
        if (await this.confirm(this.$t('PD.CERTIFY_ADULT'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: returnUrlPath } // redirectUrl: 인증완료 후 리턴할 상품화면
          })
        }
      } else if (this.mb.mbMngNo !== undefined && this.adltCtfcCd === '03') { // 로그인 되어 있고 성인인증 인증만료
      //  const url = this.$route.path
        if (await this.confirm(this.$t('PD.CERTIFY_ADULT_EXPIRED'), { center: true, dangerouslyUseHTMLString: true })) {
          this.$router.push({
            name: 'mb-mbc-SCR_MBC_0110A_01',
            path: '/mb/mbc/SCR_MBC_0110A_01',
            params: { redirectUrl: returnUrlPath } // redirectUrl: 인증완료 후 리턴할 상품화면
          })
        }
      } else {
      // 로그인되어 있고 성인인증도 되어있으면 상품상세로 이동....
        this.sendFeedback(obj)
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
      }
    },
    async detailAdultCert (obj) { // 상품설명 클릭시 성인인증 필요한 상품 , 판매예정?상품 처리
      if (obj.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
        this.adultCert(obj)
      } else if (obj.wrhParmDt && obj.sleStsCd === '02') { // 판매예정인경우
        if (this.unitType === 'Release') {
          this.sendFeedback(obj)
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
        } else {
          await this.confirm(this.$t('PD.NOTIFY_PD_CONFIRM')).then(() => {
            this.sendFeedback(obj)
            this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
          })
        }
      } else {
        this.sendFeedback(obj)
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
      }
    },

    sendFeedback (obj) {
      if (this.isNotEmpty(obj.keyword) || this.isNotEmpty(this.searchTerm)) {
        const params = {
          ip: process.env.SSN_FD_IP,
          port: '5555', // 고정값
          collection: 'GOODS',
          keyword: this.isNotEmpty(obj.keyword) ? obj.keyword : this.searchTerm,
          clickedId: obj.pdNo,
          clickCount: 1
        }
        this.$AxiosBuilder
          .params(params)
          .baseURL(process.env.API_SSN_FD_BASE_URL)
          .build()
          .get('/sendFeedback')
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    muted (event) { // 음소거 이벤트 전달 23.10.13
      this.$emit('muted-chk', {
        ref: event.ref,
        id: event.id,
        checked: event.chk
      })
    },
    play (id) { // 재생 이벤트 전달 23.10.13
    //  console.log('ref', ref)
    //  this.$emit('play-event', ref, id)
      this.$refs['video' + id].player.play()
    },
    stop (id) { // 정지 이벤트 전달 23.10.13
    // console.log('ref', ref)
    // this.$emit('stop-event', ref, id)
      this.$refs['video' + id].player.pause()
    },
    // setNoimage () {
    //   console.log('image:::', this.item.pdImgUrl, ':: ', this.isNotEmpty(this.item.pdImgUrl))
    //   if (!this.isNotEmpty(this.item.pdImgUrl)) {
    //     // eslint-disable-next-line vue/no-mutating-props
    //     this.item.pdImgUrl = '/images/tempLy/goods_img_6.png'
    //   }
    // }
    getExbtVideoUrl (videoUrl, imageUrl) { // 기획전 video 모바일 리사이징 옵션 추가
      console.log(videoUrl)
      let result
      let video = {}

      if (this.isNotEmpty(videoUrl)) {
        video = { // video 기본 옵션 설정
          controls: false, // 컨트롤 바 노출 여부
          autoplay: false, // 자동재생
          muted: true, // 음소거
          loop: true,
          // poster: imageUrl,
          playsinline: true, // 아이폰에서 자동재생 안되는 경우
          preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
          sources: [
            {
              src: videoUrl ? this.imgUrlMaker(videoUrl) + '/xcdr/preset/_480p' : '',
              type: 'video/mp4'
            }
          ],
          playbackRates: [1] // 배속
        }

        result = video
      }

      return result
    },
    getExbtImgUrl (imgUrl) { // 기획전 image 모바일 리사이징 옵션 추가
      const returnUrl = this.isNotEmpty(imgUrl) ? imgUrl + '/dims/resize/411/quality/85' : null
      return this.imgUrlMaker(returnUrl)
    },
    inctCnt (value) {
      let resultStr = 0.0
      if (value >= 100 && value <= 9999) {
        return this.numberComma(Number(value)) + '명 봤어요'
      } else if (value >= 10000 && value <= 999999) {
        resultStr = Math.round(value / 10000 * 10) / 10
        return resultStr.toLocaleString() + '만 봤어요'
      } else if (value > 999999) {
        return '99.9+만 봤어요'
      } else {
        return ''
      }
    },
    cttsReload () {
      this.$emit('cttsReload')
    }

  }

}

